import { render } from "./EditPageView.vue?vue&type=template&id=225ec33f&scoped=true"
import script from "./EditPageView.vue?vue&type=script&lang=js"
export * from "./EditPageView.vue?vue&type=script&lang=js"

import "./EditPageView.vue?vue&type=style&index=0&id=225ec33f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-225ec33f"]])

export default __exports__